import {
  Event,
  EventStatusType,
  ImageObject,
  Organization,
  Person,
  WithContext,
} from "schema-dts";

export const generateEventSchema = (event: {
  name: string;
  startDate: string;
  endDate: string;
  location: string;
  description: string;
  image?: ImageObject | ImageObject[] | string | string[];
  about?: string;
  organizer?: Organization;
  actor?: Person;
  doorTime?: string;
  duration?: string;
  inLanguage?: string;
  eventStatus?: EventStatusType;
}): WithContext<Event> => {
  return {
    "@context": "https://schema.org",
    "@type": "Event",
    name: event.name,
    startDate: event.startDate,
    endDate: event.endDate,
    location: event.location,
    description: event.description,
    image: event.image,
    about: event.about,
    organizer: event.organizer,
    actor: event.actor,
    doorTime: event.doorTime,
    duration: event.duration,
    inLanguage: event.inLanguage,
    eventStatus: event.eventStatus,
  };
};
